import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { PrimeReactProvider } from "primereact/api";
import "primeflex/primeflex.css";
import 'primereact/resources/themes/lara-light-cyan/theme.css'; // O el tema que prefieras
// import 'primereact/resources/themes/saga-blue/theme.css'; // ← Puedes cambiar el tema

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "./index.css"; // Para estilos personalizados
import  'primereact/tooltip';

import './css/bc4fc671c026af95.css';
// import './css/7e1313103c68518e.css';
// import './css/App.css';
ReactDOM.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
